function setmarqueewidth() {
        var el = document.querySelector(".desires-nowrap"); 
        var initialitems = document.querySelector(".initial-two-desires"); 
        var marqueewidth = $(el).width();
        var initialwidth = $(initialitems).width();
        $(el).attr('data-width', `${marqueewidth}`).attr('data-initial-width', `${initialwidth}`);
        animatemarquee(el,initialwidth,marqueewidth)
}
    
$(function () {
setmarqueewidth();
});

window.addEventListener("resize", setmarqueewidth);


function animatemarquee(el,initialwidth,marqueewidth) {
 
    speed = $('.desire-item-header').length * 5000;
  
    animatedmarquee = el.animate([
      { transform: 'translateX(0)' }, 
      { transform: `translateX(-${initialwidth/2}px)` }
    ], {
      duration: speed,
      iterations: 999999
    }) 
  }